<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('addSubject' )}}

            <v-spacer/>

            <v-btn @click="$store.commit('setCreateSubjectDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                    <v-text-field v-model="getSubject.name" :rules="nameRules" :label="$i18n.t('name')" class="pa-0 ma-0"/>
                    <v-text-field v-model="getSubject.code" :rules="codeRules" :label="$i18n.t('code')" class="pa-0 ma-0"/>
                    <v-select
                        :items="getTitles"
                        item-value="id"
                        item-text="name"
                        v-model="getSubject.titleId"
                        :label="$i18n.t('title')"
                        :rules="titleRules"/>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            nameRules: [
                v => !!v || this.$i18n.t('noName'),
                v => !v || v.length < 255 || this.$i18n.t('longName'),
            ],
            codeRules: [
                v => !!v || this.$i18n.t('noName'),
                v => !v || v.length < 10 || this.$i18n.t('longCode'),
            ],
            titleRules: [
                v => !!v || this.$i18n.t('noName'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('createSubject')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getCreateSubjectDialog',
            'getSubject',
            'getTitles',
        ]),
    },

    watch: {
        getCreateSubjectDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>
